__turbopack_context__.v({
  "messages": "Messages-module__DUF5Mq__messages",
});
